module.exports = __webpack_public_path__ + "static/img/JACK-CLEAVER.9a605f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JACK-CLEAVER.jpg
// module id = 78KB
// module chunks = 0